import { styled } from 'styled-components';

import { responsive } from '@/utils';

export const StyledPositionGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr auto;
  column-gap: ${responsive.spacing.xlarge};
  row-gap: ${responsive.spacing.large};
  align-items: center;
  width: 100%;
`;

export const StyledColumnHeader = styled.div`
  grid-column: 3 / span 2;
  justify-self: start;
`;
